import { useState, useEffect } from 'react';
import styled from 'styled-components';

export const OuterLayout = styled.section`
  padding: 0 18rem;

  @media screen and (max-width: 1566px) {
    padding: 0 10rem;
  }
  @media screen and (max-width: 1366px) {
    padding: 0 8rem;
  }
  @media screen and (max-width: 1186px) {
    padding: 0 6rem;
  }
  @media screen and (max-width: 990px) {
    padding: 0 4rem;
  }
  @media screen and (max-width: 768px) {
    padding: 0 4rem;
    text-align: center;
  }
`;

export const InnerLayout = styled.section`
  padding: 8rem 0;
`;

export function useMediaQuery(query) {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }
    const listener = () => {
      setMatches(media.matches);
    };
    media.addListener(listener);
    return () => media.removeListener(listener);
  }, [matches, query]);

  return matches;
}

export const useIsSmall = () => useMediaQuery('(min-width: 480px)');
export const useIsMedium = () => useMediaQuery('(min-width: 768px)');
